
<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>

<div class="giga-login">
    <div class="row">
      <div class="col-lg-6">
        <div class="giga-login_wrapper">
          <div class="giga-login_form">
            <h2 class="giga-login_title">Vérifier votre adresse e-mail</h2>

            <div class="giga-login_form_content">
                <p>Nous avons envoyé un lien de réinitialisation <br/> du mot de passe à votre adresse e-mail.</p>
                <br/>
                <p>Vous n'avez pas reçu le mail? <a href="#!">Cliquez ici</a></p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="row">
          <div class="giga-login_content">
          <div class="giga-login_content_box">
            <img src="@/assets/images/Gigawhat_Official_Logo.svg" alt="">
            <h2>Plateforme 360° de gestion des CEE</h2>
            <p>Découvrez la plateforme la plus complète du marché: création d'opérations, simulation de volumes, veille règlementaire, facturation en ligne.</p>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'EmailVerification'
}
</script>